<template>
    <v-container>
        <v-card style="border-radius: 8px;">
            <v-layout>
              <v-flex xs2 class="ml-5 mt-4">
                <div class="mt-0 body-2">Disable keyboard inputs</div> 
                </v-flex>
                <v-flex xs2> 
                <v-switch 
                        v-model="cpmenu[0].composer_input_disabled"
                        v-on:change="disableInput">
                </v-switch>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs2 class="ml-5">
                <div class="mt-0 body-2">Persistence menu</div> 
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-container grid-list-xl>
                        <v-layout row fill-height>                            
                        <v-flex xs4 >                      
                            <v-list v-if="pmenu" dense two-line>
                                <template v-for="(item, index) in cpmenu[0].call_to_actions">                                    
                                    <v-card flat  :key="item.title"> 
                                    <v-list-tile
                                        :key="item.title"
                                        ripple
                                        >
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                            <v-list-tile-sub-title class="text--primary">{{ item.type }}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title>{{ item.url }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                                <v-card-actions>
                                                <v-btn @click="editMenuItem('first',index)" flat icon color="grey lighten-1">
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn @click="deleteMenuItem('first',index)" flat icon color="grey lighten-1">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>                                               
                                                <v-btn v-if="item.type == 'nested' && firstsubmenuindex != index" @click="expandSubmenu('first',index,null,null)" flat icon color="grey lighten-1">
                                                    <v-icon>keyboard_arrow_right</v-icon>
                                                </v-btn>
                                                <v-btn v-if="item.type == 'nested' && firstsubmenuindex == index" @click="closeSubmenu('first')" flat icon color="primary">
                                                    <v-icon>keyboard_arrow_left</v-icon>
                                                </v-btn>
                                                </v-card-actions>                                                                                            
                                        </v-list-tile-action>
                                    </v-list-tile>                                    
                                    </v-card>                                   
                                    <v-divider
                                        v-if="index + 1 < cpmenu[0].call_to_actions.length"
                                        :key="index"
                                    ></v-divider>
                                </template>
                            </v-list>                             
                            <v-list v-if="firstlevellength < 3">
                                <v-btn color="primary" flat block @click="show($event,'first')">+ add button </v-btn>
                            </v-list>
                                <v-menu v-model="showMenu"
                                    :position-x="x"
                                    :position-y="y"
                                    offset-x
                                    :close-on-content-click="false"
                                    :nudge-width="400">
                                <v-card>
                                    <v-container>
                                        <v-card-actions class="justify-space-between">
                                                <v-btn flat round :color="menutype == 'postback' ? 'primary' : ''" @click="selectMenuType('postback')">
                                                    Link response
                                                </v-btn>                                            
                                                <v-btn flat round :color="menutype == 'web_url' ? 'primary' : ''" @click="selectMenuType('web_url')">
                                                    Weblink
                                                </v-btn>
                                                <!-- <v-btn flat round :color="menutype == 'nested' ? 'primary' : ''" @click="selectMenuType('nested')">
                                                    Submenu
                                                </v-btn> -->
                                        </v-card-actions>
                                        <v-text-field
                                            class="ma-3 pa-0"
                                            label="Button Name"
                                            v-model="buttonname"
                                        ></v-text-field>
                                        <v-select
                                            v-if="menutype == 'postback'"
                                            class="ma-3 pa-0"
                                            label="Response Name"
                                            :items="cresponses"
                                            v-model="responsename"
                                            item-text="name"
                                            item-value="id"
                                        ></v-select>
                                        <v-text-field
                                            v-if="menutype == 'web_url'"
                                            class="ma-3 pa-0"
                                            label="Weburl"
                                            v-model="weburl"
                                        ></v-text-field>
                                        <v-select
                                            v-if="menutype == 'web_url'"
                                            class="ma-3 pa-0"
                                            :items="webviewsizes"
                                            label="Web view Size"
                                            v-model="webviewsize"
                                        ></v-select>
                                        <div v-if="menutype == 'nested'">
                                            *Atleast one submenu item need to create
                                        </div>
                                        <v-card-actions class="justify-space-between">
                                                <v-spacer></v-spacer>                                           
                                                <v-btn v-if="saveType == 'new' && menutype != 'nested'" flat round color="primary" @click="save($event,'first',null, null)">
                                                    Save
                                                </v-btn>
                                                <v-btn v-if="saveType == 'edited' " flat round color="primary" @click="saveEditedMenu('first',null,null)">
                                                    Save Changes
                                                </v-btn>
                                                <v-btn v-if="menutype == 'nested' && saveType != 'edited'" flat round color="primary" @click="save($event,'first',null, null)">
                                                    Proceed
                                                </v-btn>
                                        </v-card-actions>                                            
                                    </v-container>
                                </v-card>
                            </v-menu>          
                        </v-flex>                        
                        <v-flex xs4 v-if="this.firstsubmenulevel">
                            <v-list dense two-line>
                                <template v-for="(item, index) in secondlevelmenu">
                                    <v-list-tile
                                        :key="item.title"
                                        avatar
                                        ripple
                                        >
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                            <v-list-tile-sub-title class="text--primary">{{ item.type }}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title>{{ item.url }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>                                                
                                                <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="editMenuItem('second',index)" flat icon color="grey lighten-1">
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn v-if="secondlevelmenu.length > 1" @click="deleteMenuItem('second',index)" flat icon color="grey lighten-1">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                                <v-btn v-if="item.type == 'nested' && secondsubmenuindex != index" @click="expandSubmenu('first',firstsubmenuindex,'second',index)" flat icon color="grey lighten-1">
                                                    <v-icon>keyboard_arrow_right</v-icon>
                                                </v-btn>
                                                <v-btn v-if="item.type == 'nested' && secondsubmenuindex == index" @click="closeSubmenu('second')" flat icon color="primary">
                                                    <v-icon>keyboard_arrow_left</v-icon>
                                                </v-btn>
                                                </v-card-actions>
                                        </v-list-tile-action>
                                    </v-list-tile>                                    
                                    <v-divider
                                        v-if="index + 1 < secondlevelmenu.length"
                                        :key="index"
                                    ></v-divider>
                                </template>
                            </v-list>
                            <v-list v-if="secondlevelmenu.length < 5">
                                <v-btn color="primary" flat block @click="show($event,'second')">+ add button </v-btn>
                            </v-list>
                            <v-menu v-model="showMenuFirstSubMenu"
                                    :position-x="x"
                                    :position-y="y"
                                    offset-x
                                    :close-on-content-click="false"
                                    :nudge-width="400">
                                <v-card>
                                    <v-container>
                                        <v-card-actions class="justify-space-between">
                                                <v-btn flat round :color="menutype == 'postback' ? 'primary' : ''" @click="selectMenuType('postback')">
                                                    Link response
                                                </v-btn>                                            
                                                <v-btn flat round :color="menutype == 'web_url' ? 'primary' : ''" @click="selectMenuType('web_url')">
                                                    Weblink
                                                </v-btn>
                                                <!-- <v-btn flat round :color="menutype == 'nested' ? 'primary' : ''" @click="selectMenuType('nested')">
                                                    Submenu
                                                </v-btn> -->
                                        </v-card-actions>
                                        <v-text-field
                                            class="ma-3 pa-0"
                                            label="Button Name"
                                            v-model="buttonname"
                                        ></v-text-field>
                                        <v-select
                                            v-if="menutype == 'postback'"
                                            class="ma-3 pa-0"
                                            label="Response Name"
                                            :items="cresponses"
                                            v-model="responsename"
                                            item-text="name"
                                            item-value="id"
                                        ></v-select>
                                        <v-text-field
                                            v-if="menutype == 'web_url'"
                                            class="ma-3 pa-0"
                                            label="Weburl"
                                            v-model="weburl"
                                        ></v-text-field>
                                        <v-select
                                            v-if="menutype == 'web_url'"
                                            class="ma-3 pa-0"
                                            :items="webviewsizes"
                                            label="Web view Size"
                                            v-model="webviewsize"
                                        ></v-select>
                                        <v-card-actions class="justify-space-between">
                                                <v-spacer></v-spacer>                                           
                                                <v-btn v-if="saveType == 'new' && menutype != 'nested'" flat round color="primary" @click="save($event,'second',firstsubmenuindex, null)">
                                                    Save
                                                </v-btn>
                                                <v-btn v-if="saveType == 'edited'" flat round color="primary" @click="saveEditedMenu('second',firstsubmenuindex,null)">
                                                    Save Changes
                                                </v-btn>
                                                <v-btn v-if="menutype == 'nested' && saveType != 'edited'" flat round color="primary" @click="save($event,'second',firstsubmenuindex, null)">
                                                    Proceed
                                                </v-btn>
                                        </v-card-actions>                                            
                                    </v-container>
                                </v-card>
                            </v-menu> 
                        </v-flex>                 
                        <v-flex xs4 v-if="this.secondsubmenulevel">            
                            <v-list dense two-line>
                                <template v-for="(item, index) in thirdlevelmenu">
                                    <v-list-tile
                                        :key="item.title"
                                        avatar
                                        ripple
                                        >
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                            <v-list-tile-sub-title class="text--primary">{{ item.type }}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title>{{ item.url }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                                <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="editMenuItem('third',index)" flat icon color="grey lighten-1">
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn v-if="thirdlevelmenu.length > 1" @click="deleteMenuItem('third',index)" flat icon color="grey lighten-1">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                                </v-card-actions>
                                        </v-list-tile-action>
                                    </v-list-tile>                                    
                                    <v-divider
                                        v-if="index + 1 < thirdlevelmenu.length"
                                        :key="index"
                                    ></v-divider>
                                </template>
                            </v-list>
                            <v-list v-if="thirdlevelmenu.length < 5">
                                <v-btn color="primary" flat block @click="show($event,'third')">+ add button </v-btn>
                            </v-list>
                            <v-menu v-model="showMenuSecondSubMenu"
                                    :position-x="x"
                                    :position-y="y"
                                    offset-x
                                    :close-on-content-click="false"
                                    :nudge-width="400">
                                <v-card>
                                    <v-container>
                                        <v-card-actions class="justify-space-between">
                                                <v-btn flat round :color="menutype == 'postback' ? 'primary' : ''" @click="selectMenuType('postback')">
                                                    Link response
                                                </v-btn>                                            
                                                <v-btn flat round :color="menutype == 'web_url' ? 'primary' : ''" @click="selectMenuType('web_url')">
                                                    Weblink
                                                </v-btn>
                                        </v-card-actions>
                                        <v-text-field
                                            class="ma-3 pa-0"
                                            label="Button Name"
                                            v-model="buttonname"
                                        ></v-text-field>
                                        <v-select
                                            v-if="menutype == 'postback'"
                                            class="ma-3 pa-0"
                                            label="Response Name"
                                            :items="cresponses"
                                            v-model="responsename"
                                            item-text="name"
                                            item-value="id"
                                        ></v-select>
                                        <v-text-field
                                            v-if="menutype == 'web_url'"
                                            class="ma-3 pa-0"
                                            label="Weburl"
                                            v-model="weburl"
                                        ></v-text-field>
                                        <v-select
                                            v-if="menutype == 'web_url'"
                                            class="ma-3 pa-0"
                                            :items="webviewsizes"
                                            label="Web view Size"
                                            v-model="webviewsize"
                                        ></v-select>
                                        <v-card-actions class="justify-space-between">
                                                <v-spacer></v-spacer>                                           
                                                <v-btn v-if="saveType == 'new'" flat round color="primary" @click="save($event,'third',firstsubmenuindex, secondsubmenuindex)">
                                                    Save
                                                </v-btn>
                                                <v-btn v-if="saveType == 'edited'" flat round color="primary" @click="saveEditedMenu('third',firstsubmenuindex, secondsubmenuindex)">
                                                    Save Changes
                                                </v-btn>
                                        </v-card-actions>                                            
                                    </v-container>
                                </v-card>
                            </v-menu> 
                        </v-flex>
                        </v-layout>  
                    </v-container>
                </v-flex>    
            </v-layout>
        </v-card>       
    </v-container>
</template>

<script>

export default {
    data(){
        return{
            showMenu: false,
            showMenuFirstSubMenu: false,
            showMenuSecondSubMenu:false,
            saveType:'new',
            x: 0,
            y: 0,
            menulevel:null,
           enabletyping:true,
           menutype:"postback",
           currentlevel:null,
           firstsubmenulevel:null,
           firstsubmenuindex:null,
           secondsubmenulevel:null,
           secondsubmenuindex:null,
           currentindex:null,
           firstlevellength:null,
           firstlevelmenu:[],
           secondlevellength:null,
           secondlevelmenu:[],
           thirdlevelmenu:[],
           thirdlevellength:null,
           webviewsizes:["COMPACT","TALL","FULL"],
           buttonname:null,
           responsename:null,
           weburl:null,
           webviewsize:null,
           pmenu:[ {
                    "locale":"default",
                    "composer_input_disabled": false,
                    "call_to_actions":[]
                    }
                ]
        }
    },
    methods:{
        show (event, level) {
            event.preventDefault()
            this.menulevel = level
            this.showMenu = false
            this.showMenuFirstSubMenu = false
            this.x = event.clientX
            this.y = event.clientY
            if(level == 'first'){
                this.showMenu = true
            }
            else if (level == 'second'){
                this.showMenuFirstSubMenu = true
            }
            else if (level == 'third'){
                this.showMenuSecondSubMenu = true
            }            
            this.saveType = 'new'
      },
      selectMenuType(menutype){
          this.menutype = menutype
      },
      disableInput(){
        let f_menu = this.pmenu
            let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "persistent_menu": f_menu
                    },
                    function (response) {
                        console.log('persistent menu updated' +response)           
                    });
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
        console.log("disable input")
      },
      save(event,level,fsm_index,ssm_index){
          console.log(level)
          var f_menu = null;
          if (this.menutype == 'postback')
          { console.log(this.pmenu)
              let s_menu = {
                                "title":this.buttonname,
                                "type":"postback",
                                "payload":this.responsename
                            }
                if(level == 'first'){
                    this.pmenu[0].call_to_actions.push(s_menu)
                    f_menu = this.pmenu
                    this.firstlevellength = this.pmenu[0].call_to_actions.length
                    console.log(f_menu)
                }
                else if (level == 'second'){
                    let index = Number(fsm_index)
                    this.pmenu[0].call_to_actions[index].call_to_actions.push(s_menu)
                    f_menu = this.pmenu
                    this.secondlevelmenu = this.pmenu[0].call_to_actions[index].call_to_actions
                }else if (level == 'third'){
                    let f_index =  Number(fsm_index)
                    let s_index =  Number(ssm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions.push(s_menu)
                    f_menu = this.pmenu
                    this.thirdlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions
                }              
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "persistent_menu": f_menu
                    },
                    function (response) {
                        console.log(f_menu)
                        console.log(response)           
                    });
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              }) 
            this.showMenu = false
            this.showMenuFirstSubMenu = false
            this.showMenuSecondSubMenu = false               
          }
          else if (this.menutype == 'web_url')
          {
                let s_menu = {
                                "type":"web_url",
                                "title":this.buttonname,
                                "url":this.weburl,
                                "webview_height_ratio":this.webviewsize
                            }
              if(level == 'first'){
                    this.pmenu[0].call_to_actions.push(s_menu)
                    f_menu = this.pmenu
                    this.firstlevellength = this.pmenu[0].call_to_actions.length
                    console.log(f_menu)
                }
                else if (level == 'second'){
                    let index = Number(fsm_index)
                    this.pmenu[0].call_to_actions[index].call_to_actions.push(s_menu)
                    f_menu = this.pmenu
                    this.secondlevelmenu = this.pmenu[0].call_to_actions[index].call_to_actions
                }else if (level == 'third'){
                    let f_index =  Number(fsm_index)
                    let s_index =  Number(ssm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions.push(s_menu)
                    f_menu = this.pmenu
                    this.thirdlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions
                }              
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                        "persistent_menu": f_menu
                    },
                    function (response) { 
                        console.log('persistent menu updated' +response)           
                    });
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              }) 
            this.showMenu = false 
            this.showMenuFirstSubMenu = false
            this.showMenuSecondSubMenu = false              
          }
          else if(this.menutype == 'nested')
          {
                let s_menu = {
                                "title":this.buttonname,
                                "type":"nested",
                                "call_to_actions":[]
                            }
                if(level == 'first'){
                    this.pmenu[0].call_to_actions.push(s_menu)
                    this.showMenu = false
                    this.firstsubmenulevel = 'first'
                    this.firstsubmenuindex = this.pmenu[0].call_to_actions.length - 1
                    this.buttonname = null
                    this.responsename = null
                    this.weburl = null
                    this.webviewsize =null
                }
                else if (level == 'second'){
                    let index = Number(fsm_index)
                    this.pmenu[0].call_to_actions[index].call_to_actions.push(s_menu)
                    this.secondlevelmenu = this.pmenu[0].call_to_actions[index].call_to_actions
                    this.showMenu = false
                    this.showMenuFirstSubMenu = false
                    this.firstsubmenulevel = 'first'
                    this.firstsubmenuindex = this.pmenu[0].call_to_actions.length - 1
                    this.secondsubmenulevel = 'second'
                    this.secondsubmenuindex = this.pmenu[0].call_to_actions[fsm_index].call_to_actions.length - 1
                    this.buttonname = null
                    this.responsename = null
                    this.weburl = null
                    this.webviewsize =null
                }
 
          }
      },
      saveEditedMenu(level,fsm_index,ssm_index){
          let index = this.currentindex
          var f_menu
          console.log(index)
          if (this.menutype == 'postback')
          { console.log(this.pmenu)
              let s_menu = {
                                "title":this.buttonname,
                                "type":"postback",
                                "payload":this.responsename
                            }
              if(level == 'first'){
                    this.pmenu[0].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.firstlevellength = this.pmenu[0].call_to_actions.length
                    console.log(f_menu)
                }
                else if (level == 'second'){
                    let f_index = Number(fsm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.secondlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions
                }else if (level == 'third'){
                    let f_index = Number(fsm_index)
                    let s_index = Number(ssm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.thirdlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions
                }               
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "persistent_menu": f_menu
                    },
                    function (response) {
                        console.log('persistent menu updated' +response)           
                    });
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              }) 
            this.showMenu = false
            this.showMenuFirstSubMenu = false
            this.showMenuSecondSubMenu = false                
          }
          else if (this.menutype == 'web_url')
          {
                let s_menu = {
                                "type":"web_url",
                                "title":this.buttonname,
                                "url":this.weburl,
                                "webview_height_ratio":this.webviewsize
                            }
                              if(level == 'first'){
                    this.pmenu[0].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.firstlevellength = this.pmenu[0].call_to_actions.length
                    console.log(f_menu)
                }
                else if (level == 'second'){
                    let f_index = Number(fsm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.secondlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions
                }else if (level == 'third'){
                    let f_index = Number(fsm_index)
                    let s_index = Number(ssm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.thirdlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions
                }             
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                        "persistent_menu": f_menu
                    },
                    function (response) { 
                        console.log('persistent menu updated' +response)           
                    });
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              }) 
            this.showMenu = false
            this.showMenuFirstSubMenu = false
            this.showMenuSecondSubMenu = false                
          }
          else if (this.menutype == 'nested')
          {
                let s_menu = {
                                "title":this.buttonname,
                                "type":"nested",
                                "call_to_actions":[]
                            }
              if(level == 'first'){
                    this.pmenu[0].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    console.log(f_menu)
                }
                else if (level == 'second'){
                    let f_index = Number(fsm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions.splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.secondlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions
                }else if (level == 'third'){
                    let f_index = Number(fsm_index)
                    let s_index = Number(ssm_index)
                    this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].splice(index,1,s_menu)
                    f_menu = this.pmenu
                    this.thirdlevelmenu = this.pmenu[0].call_to_actions[f_index].call_to_actions[s_index].call_to_actions
                }
            //     let pageid = this.$store.state.pageDetails
            //   FB.getLoginStatus(function(response) {
            //     if(response.status == 'connected') {                     
            //         FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
            //         'POST',
            //         { 
            //             "persistent_menu": f_menu
            //         },
            //         function (response) {
            //             console.log('persistent menu updated' +response)           
            //         });
            //     }
            //     else{    
            //         console.log("unable to get login status") 
            //     } 
                
            //   }) 
            this.showMenu = false 
            this.showMenuFirstSubMenu = false
            this.showMenuSecondSubMenu = false             
          }
      },
      deleteMenuItem(level,index){
          if(level == 'first'){
              this.pmenu[0].call_to_actions.splice(index,1)
              if(this.pmenu[0].call_to_actions.length >= 1){
              let f_menu = this.pmenu
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "persistent_menu": f_menu
                    },
                    function (response) {
                        console.log(response)           
                    });
                    
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
            console.log("delete menu item")
            this.firstlevellength = this.pmenu[0].call_to_actions.length
            this.firstsubmenulevel = null
          }
          else{
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'DELETE',
                    {"fields":["persistent_menu"]},
                    function (response) {
                         console.log(response)           
                     });
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
            console.log("delete menu item")
            this.firstsubmenulevel = null
            this.firstlevellength = 0
           }
          } 
          else if(level == 'second'){
              this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions.splice(index,1)
              let f_menu = this.pmenu
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "persistent_menu": f_menu
                    },
                    function (response) {
                        console.log(response)           
                    });
                    
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
            console.log("delete menu item")
            this.secondsubmenulevel = null
          }
          else if(level == 'third'){
              this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions.splice(index,1)
              let f_menu = this.pmenu
              let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "persistent_menu": f_menu
                    },
                    function (response) {
                        console.log(response)           
                    });
                    
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
            console.log("delete menu item")
          }
      },
      editMenuItem(level,index)
      {
          this.currentindex=index
          if(level == 'first'){
                this.buttonname = this.pmenu[0].call_to_actions[index].title
              if(this.pmenu[0].call_to_actions[index].type == 'postback')
              {
                  this.responsename = this.pmenu[0].call_to_actions[index].payload
                  this.menutype="postback"
              }
              else if (this.pmenu[0].call_to_actions[index].type == 'web_url')
              {
                  this.weburl  = this.pmenu[0].call_to_actions[index].url
                  this.webviewsize = this.responsename = this.pmenu[0].call_to_actions[index].webview_height_ratio
                  this.menutype="web_url"
              }
              else if (this.pmenu[0].call_to_actions[index].type == 'nested'){
                  this.menutype="nested"
              }
                this.x = event.clientX
                this.y = event.clientY
                this.menulevel = level
                this.showMenu = true
                this.saveType = 'edited'
          }
          else if(level == 'second'){
            this.buttonname = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].title              
                if(this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].type == 'postback')
              {
                  this.responsename = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].payload
                  this.menutype="postback"
              }
              else if (this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].type == 'web_url')
              {
                  this.weburl = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].url
                  this.webviewsize =  this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].webview_height_ratio
                  this.menutype="web_url"
              }
              else if (this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[index].type == 'nested'){
                  this.menutype="nested"
              }
                this.x = event.clientX
                this.y = event.clientY
                this.menulevel = level
                this.showMenuFirstSubMenu = true
                this.saveType = 'edited'
          }
          else if(level == 'third'){
              this.buttonname = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions[index].title
                if(this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions[index].type == 'postback')
              {
                  this.responsename = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions[index].payload
                  this.menutype="postback"
              }
              else if (this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions[index].type == 'web_url')
              {
                  this.weburl = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions[index].url
                  this.webviewsize = this.pmenu[0].call_to_actions[this.firstsubmenuindex].call_to_actions[this.secondsubmenuindex].call_to_actions[index].webview_height_ratio
                  this.menutype="web_url"
              }
                this.x = event.clientX
                this.y = event.clientY
                this.menulevel = level
                this.showMenuSecondSubMenu = true
                this.saveType = 'edited'
          }
          
      },
      expandSubmenu(flevel,findex,slevel,sindex){
          this.firstsubmenulevel = flevel
          this.firstsubmenuindex = findex
          this.secondsubmenulevel = slevel
          this.secondsubmenuindex = sindex
          this.secondlevelmenu = this.pmenu[0].call_to_actions[findex].call_to_actions
          if (slevel != null){
            this.thirdlevelmenu = this.pmenu[0].call_to_actions[findex].call_to_actions[sindex].call_to_actions
          }
      },
      closeSubmenu(level){
          if (level == 'first'){
            this.firstsubmenulevel = null
            this.firstsubmenuindex = null
            this.secondsubmenulevel = null
            this.secondsubmenuindex = null
            this.secondlevelmenu = null
            this.thirdlevelmenu = null
          }
          else if (level == 'second'){

          }          
          this.secondsubmenulevel = null
          this.secondsubmenuindex = null
          this.thirdlevelmenu = null
          
      },
      fetchPageData(){
       this.$store.dispatch('afetchresponses') 
      }
      

    },
    mounted(){
       // this.fetchPageData()
       // not working here add at view level. need to check this.
    },
    computed:{
        cpmenu(){
             if (this.$store.state.pageDetails.persistent_menu != undefined){
                    this.pmenu = this.$store.state.pageDetails.persistent_menu
                    console.log(this.pmenu)  
                    //this.firstlevelmenu = this.$store.state.pageDetails.persistent_menu [0].call_to_actions
                    this.firstlevellength = this.$store.state.pageDetails.persistent_menu [0].call_to_actions.length         
                    console.log("menu"+this.pmenu)
                return this.pmenu
             }
             else{
                 this.pmenu = [ {
                    "locale":"default",
                    "composer_input_disabled": false,
                    "call_to_actions":[]
                    }
                ]
                 return this.pmenu
             }
            
        },
    cresponses(){
        console.log(this.$store.state.responses)
            return this.$store.state.responses
        }
    }   
}
</script>
